import { Field, Input, Label, Tab, TabList } from "@fluentui/react-components";
import React from "react";
import { StreamModel } from "../../edit-experiment.models";
import { ExperimentStreamType, SeparationMethodOption } from "../../../../swagger-clients/ai-for-pfd-clients.service";
import { StreamComponent } from "./stream.component";
import { IExperimentValidation } from "../../edit-experiment.validation";

type AbsorptionStreamProps = {
    streams: StreamModel[];
    onChange: (streams: StreamModel[]) => void;
    isDetails?: boolean;
    isFormSubmitted?: boolean;
    experimentValidation?: IExperimentValidation;
    separationMethod: SeparationMethodOption;
}

export const AbsorptionStream: React.FC<AbsorptionStreamProps> = (props) => {
    const [selectedTab, setSelectedTab] = React.useState<string>("feed");


    const feedStreamIndex = props.streams.findIndex(x => x.streamType == ExperimentStreamType.Feed);
    const solventStreamIndex = props.streams.findIndex(x => x.streamType == ExperimentStreamType.Solvent);
    const feedStreamValidation = feedStreamIndex > -1 && !!props.experimentValidation?.streams[feedStreamIndex] ? props.experimentValidation?.streams[feedStreamIndex] : undefined;
    const solventStreamValidation = solventStreamIndex > -1 && !!props.experimentValidation?.streams[solventStreamIndex] ? props.experimentValidation?.streams[solventStreamIndex] : undefined;



    const onStreamDataChange = (data: StreamModel) => {

        const updatedStreams = props.streams.map(stream => {
            if (stream.streamType === data.streamType) {
                return { ...data, compositions: [...data.compositions] } as StreamModel;
            }
            return stream;
        });
        props.onChange(updatedStreams);
    }


    return <div style={{ marginTop: "-15px" }}>
        <TabList selectedValue={selectedTab} onTabSelect={(ev, data) => { setSelectedTab(data.value as string); }}>
            <Tab key="feed" value="feed" >Feed</Tab>
            <Tab key="solvent" value="solvent" >Solvent</Tab>
        </TabList>

        <div className="tab-content" style={{ marginTop: "10px" }}>
            <div className="row">
                {selectedTab === "feed" &&
                    <StreamComponent
                        key="feed-stream"
                        separationMethod={props.separationMethod}
                        stream={props.streams[feedStreamIndex]}
                        onChange={(data) => onStreamDataChange(data)}
                        isDetails={props.isDetails}
                        isFormSubmitted={props.isFormSubmitted}
                        streamValidation={feedStreamValidation}
                    />}
                {selectedTab === "solvent" &&
                    <StreamComponent
                        key="solvent-stream"
                        separationMethod={props.separationMethod}
                        disableEditComposition
                        stream={props.streams[solventStreamIndex]}
                        onChange={(data) => onStreamDataChange(data)}
                        isDetails={props.isDetails}
                        isFormSubmitted={props.isFormSubmitted}
                        streamValidation={solventStreamValidation}
                    />}
            </div>

        </div>

    </div>
}